import React from 'react';
import { useAuth, redirectToIdentityLogin } from '../contexts/AuthContext';
import { ShieldAlert } from 'lucide-react';

export default function NoAccess() {
  const { logout, user } = useAuth();

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[#0D1117] p-6"
      data-testid="no-access-page"
    >
      <div
        className="max-w-md w-full rounded-2xl p-10 text-center border border-white/[0.08]"
        style={{ background: 'rgba(22, 27, 34, 0.85)', backdropFilter: 'blur(16px)' }}
      >
        <div className="w-14 h-14 rounded-full bg-red-500/10 border border-red-500/30 flex items-center justify-center mx-auto mb-5">
          <ShieldAlert className="w-7 h-7 text-red-400" />
        </div>
        <h1 className="font-heading text-xl font-semibold text-white mb-2">
          Geen toegang tot Vault
        </h1>
        <p className="text-sm text-[#8B949E] mb-6">
          {user?.email ? (
            <>Je account <span className="text-[#C9D1D9]">{user.email}</span> heeft geen toegang tot deze applicatie.</>
          ) : (
            <>Je account heeft geen toegang tot deze applicatie.</>
          )}
          <br />
          Neem contact op met een beheerder om toegang aan te vragen.
        </p>
        <div className="flex flex-col sm:flex-row gap-2 justify-center">
          <button
            onClick={() => logout()}
            data-testid="no-access-logout"
            className="px-4 py-2 rounded-lg bg-[#2E75B6] text-white text-sm font-medium hover:bg-[#27649C] transition-colors"
          >
            Uitloggen
          </button>
          <button
            onClick={() => redirectToIdentityLogin()}
            data-testid="no-access-switch-account"
            className="px-4 py-2 rounded-lg border border-[#30363D] text-[#C9D1D9] text-sm hover:bg-[#21262D] transition-colors"
          >
            Ander account gebruiken
          </button>
        </div>
      </div>
    </div>
  );
}
